import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminRemoveFormContainer from './AdminRemoveFormContainer';
import AdminSideSlides from '../../AdminLayout/AdminSideSlides';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import KioskIdelScreen from '../../KioskLayout/KioskIdelScreen';

const messages = defineMessages({
  ScanStockCode: {
    id: 'Admin.Stock.ScanStockCode',
    defineMessages: 'Scan the stock code to begin.'
  }
});
export class AdminRemoveLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle:
      this.props && this.props.intl.formatMessage(messages.ScanStockCode),
    height: 300
  };

  render() {
    return (
      <>
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminRemoveFormContainer />
        <KioskIdelScreen />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const kiosk = state.get('kiosk');
  return { ...kiosk };
};

export default connect(mapStateToProps)(injectIntl(AdminRemoveLayout));
